export var EProgressStepsOrientation = /* @__PURE__ */ ((EProgressStepsOrientation2) => {
  EProgressStepsOrientation2["HORIZONTAL"] = "horizontal";
  EProgressStepsOrientation2["VERTICAL"] = "vertical";
  return EProgressStepsOrientation2;
})(EProgressStepsOrientation || {});
export var EProgressStepsElements = /* @__PURE__ */ ((EProgressStepsElements2) => {
  EProgressStepsElements2["ROOT"] = "root";
  EProgressStepsElements2["ITEM"] = "item";
  EProgressStepsElements2["STEPBLOCK"] = "stepBlock";
  EProgressStepsElements2["TEXTBLOCK"] = "textBlock";
  EProgressStepsElements2["TITLE"] = "title";
  EProgressStepsElements2["DESCRIPTION"] = "description";
  return EProgressStepsElements2;
})(EProgressStepsElements || {});
